import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { SQLiteObject } from '@ionic-native/sqlite';
import { DatabaseProvider } from '../database/database';
import { Device } from '@ionic-native/device';
import { Storage } from '@ionic/storage';

@Injectable()
export class ClienteProvider {


  constructor(public dbProvider: DatabaseProvider,
    public device: Device,
    public storage: Storage) {

  }

  retiraMascara(s) {
    if (s == null || s == undefined) {
      return "";
    } else {
      let map = { "-": "", "(": "", ")": "", ".": "", "/": "", " ": "" };
      return s.replace(/[\W\[\] ]/g, (a) => {
        return map[a] || a
      });
    }
  }

  removerAcentos(s) {
    if (s == null || s == undefined) {
      return "";
    } else {
      let map = { "â": "a", "Â": "A", "à": "a", "À": "A", "á": "a", "Á": "A", "ã": "a", "Ã": "A", "ê": "e", "Ê": "E", "è": "e", "È": "E", "é": "e", "É": "E", "î": "i", "Î": "I", "ì": "i", "Ì": "I", "í": "i", "Í": "I", "õ": "o", "Õ": "O", "ô": "o", "Ô": "O", "ò": "o", "Ò": "O", "ó": "o", "Ó": "O", "ü": "u", "Ü": "U", "û": "u", "Û": "U", "ú": "u", "Ú": "U", "ù": "u", "Ù": "U", "ç": "c", "Ç": "C" };
      return s.replace(/[\W\[\] ]/g, (a) => {
        return map[a] || a
      });
    }
  }

  public getNewCodigo() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT COALESCE(MIN(Cli_Codigo), -1) AS Codigo FROM clientes WHERE Cli_Codigo < 0';

        return db.executeSql(sql, []).then((data: any) => {
          if (data.rows.length > 0) {
            return data.rows.item(0).Codigo;
          } else {
            return -1;
          }
        })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  async insertNovoCliente(cliente: Cliente) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into clientes (Cli_Codigo, Cli_NomeFantasia, Cli_RazaoSocial, Cli_CPFCNPJ, ' +
            'Cli_RGIE, Cli_Email, Cli_Fone1, Cli_Endereco, Cli_NroEndereco, ' +
            'Cli_Bairro, Cli_Complemento, Cli_CEP, Cli_Cidade, Cli_UF, Cli_CadastradoApp, Dev_UUID, Cli_Status) ' +
            'VALUES((SELECT COALESCE(MIN(Cli_Codigo) -1, -1) FROM clientes WHERE Cli_Codigo < 0), ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)';

          let params = [this.removerAcentos(cliente.nomefantasia), this.removerAcentos(cliente.razaosocial), this.retiraMascara(cliente.cpf_cnpj),
          this.retiraMascara(cliente.rg_ie), cliente.email, this.retiraMascara(cliente.fone1), this.removerAcentos(cliente.endereco), cliente.nro_endereco,
          this.removerAcentos(cliente.bairro), this.removerAcentos(cliente.complemento), this.retiraMascara(cliente.cep), this.removerAcentos(cliente.cidade),
          cliente.uf, 'S', this.device.uuid, 'A'];

          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('cadastrou cliente');
          }, (err) => {
            console.log('erro cadastro cliente:');
            console.log(err);
          });

        }).then();

      })
      .catch((e) => console.error(e));
  }


  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into clientes (Cli_Codigo, Cli_NomeFantasia, Cli_RazaoSocial, Cli_CPFCNPJ, ' +
            'Cli_RGIE, Cli_Email, Cli_Fone1, Cli_Fone2, Cli_Fax, Cli_Celular, Cli_Whats, Cli_Endereco, Cli_NroEndereco, ' +
            'Cli_Bairro, Cli_Complemento, Cli_CEP, Cli_Cidade, Cli_UF, Cli_CodMunicipio, Cli_Bloquear,' +
            'Cli_MotivoBloqueio, Cli_CadastradoApp, Cli_Status, Rot_Codigo) ' +
            'VALUES(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)';
          for (let val of data) {
            let cliente = new Cliente();
            cliente.codigo = val.Cli_Codigo;
            cliente.nomefantasia = val.Cli_NomeFantasia;
            cliente.razaosocial = val.Cli_RazaoSocial;
            cliente.cpf_cnpj = val.Cli_CPFCNPJ;
            cliente.rg_ie = val.Cli_RGIE;
            cliente.email = val.Cli_Email;
            cliente.fone1 = val.Cli_Fone1;
            cliente.fone2 = val.Cli_Fone2;
            cliente.fax = val.Cli_Fax;
            cliente.whatsapp = val.Cli_Whats;
            cliente.celular = val.Cli_Celular;
            cliente.endereco = val.Cli_Endereco;
            cliente.nro_endereco = val.Cli_NroEndereco;
            cliente.bairro = val.Cli_Bairro;
            cliente.complemento = val.Cli_Complemento;
            cliente.cep = val.Cli_CEP;
            cliente.cidade = val.Cli_Cidade;
            cliente.uf = val.Cli_UF;
            cliente.codigo_municipio = val.Cli_CodMunicipio;
            cliente.bloquear = val.Cli_Bloquear;
            cliente.motivo_bloqueio = val.Cli_MotivoBloqueio;
            cliente.status = val.Cli_Status;
            cliente.codigo_rota = val.Rot_Codigo;

            let params = [cliente.codigo, cliente.nomefantasia, cliente.razaosocial, cliente.cpf_cnpj,
            cliente.rg_ie, cliente.email, cliente.fone1, cliente.fone2, cliente.fax, cliente.celular, cliente.whatsapp, cliente.endereco, cliente.nro_endereco,
            cliente.bairro, cliente.complemento, cliente.cep, cliente.cidade, cliente.uf, cliente.codigo_municipio, cliente.bloquear,
            cliente.motivo_bloqueio, 'N', cliente.status, cliente.codigo_rota];

            await tx.executeSql('DELETE FROM clientes_tabelapreco where Cli_Codigo = ?', [cliente.codigo], (tx, resultSet) => {
              console.log('deletou clientes_tabelapreco ' + cliente.codigo);
            }, (err) => {
              console.log('erro deletar clientes_tabelapreco:');
              console.log(err);
            });

            await tx.executeSql('DELETE FROM clientes where Cli_Codigo = ?', [cliente.codigo], (tx, resultSet) => {
              console.log('deletou cliente ' + cliente.codigo);
            }, (err) => {
              console.log('erro deletar cliente:');
              console.log(err);
            });

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou cliente ' + cliente.codigo);
              console.log('ultima alteração ' + val.Cli_Alteracao);
              this.storage.set('ultimaDataCliente', val.Cli_DTHRAlteracao);
              this.storage.set('ultimaAlteracaoCliente', val.Cli_Alteracao);
            }, (err) => {
              console.log('erro cliente:');
              console.log(err);
            });

            for (let item of val.Tabelas) {
              let sql2 = 'insert into clientes_tabelapreco(Tab_Codigo, Cli_Codigo) values (?, ?)';
              let params2 = [item.Tab_Codigo, val.Cli_Codigo];

              await tx.executeSql(sql2, params2, (tx, resultSet) => {
                console.log('importou cliente - tabela de preço');
              }, (err) => {
                console.log('erro cliente tabPreco:');
                console.log(err);
              });

            }

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public get(codCliente = 0) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM clientes ' +
          'WHERE ' +
          '  Cli_Codigo = ? ';

        return db.executeSql(sql, [codCliente])
          .then((data: any) => {
            if (data.rows.length > 0) {
              var cliente = new Cliente();
              cliente.codigo = data.rows.item(0).Cli_Codigo;
              cliente.nomefantasia = data.rows.item(0).Cli_NomeFantasia;
              cliente.razaosocial = data.rows.item(0).Cli_RazaoSocial;
              cliente.cpf_cnpj = data.rows.item(0).Cli_CPFCNPJ;
              cliente.rg_ie = data.rows.item(0).Cli_RGIE;
              cliente.email = data.rows.item(0).Cli_Email;
              cliente.fone1 = data.rows.item(0).Cli_Fone1;
              cliente.fone2 = data.rows.item(0).Cli_Fone2;
              cliente.fax = data.rows.item(0).Cli_Fax;
              cliente.whatsapp = data.rows.item(0).Cli_Whats;
              cliente.celular = data.rows.item(0).Cli_Celular;
              cliente.endereco = data.rows.item(0).Cli_Endereco;
              cliente.nro_endereco = data.rows.item(0).Cli_NroEndereco;
              cliente.bairro = data.rows.item(0).Cli_Bairro;
              cliente.complemento = data.rows.item(0).Cli_Complemento;
              cliente.cep = data.rows.item(0).Cli_CEP;
              cliente.cidade = data.rows.item(0).Cli_Cidade;
              cliente.uf = data.rows.item(0).Cli_UF;
              cliente.codigo_municipio = data.rows.item(0).Cli_CodMunicipio;
              cliente.bloquear = data.rows.item(0).Cli_Bloquear;
              cliente.motivo_bloqueio = data.rows.item(0).Cli_MotivoBloqueio;
              cliente.cadastrado_app = data.rows.item(0).Cli_CadastradoApp;
              cliente.codigo_rota = data.rows.item(0).Rot_Codigo;
              return cliente;
            } else {
              return new Cliente();
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }


  public getAll(search: string = null, codUsuario = 0, codRota = 0) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM clientes ' +
          'WHERE ' +
          '  COALESCE(Cli_Status, "A") = "A" ' +
          ' AND ((Cli_Codigo > 0) OR (Cli_CadastradoApp = "S")) ';
        let data = [];
        if (search) {
          sql += ' AND (Cli_NomeFantasia like ? ';
          sql += '   OR Cli_RazaoSocial like ?';
          sql += '   OR Cli_Fone1 like ?';
          sql += '   OR Cli_Fone2 like ?';
          sql += '   OR Cli_Celular like ?';
          sql += '   OR Cli_Whats like ?';
          sql += '   OR Cli_Fax like ?';
          sql += '   OR Cli_Endereco || ", " || COALESCE(Cli_NroEndereco, 0) like ?';
          sql += '   OR Cli_Endereco || " " || COALESCE(Cli_NroEndereco, 0) like ?';
          sql += '   OR Cli_Endereco || "," || COALESCE(Cli_NroEndereco, 0) like ?';
          sql += '   OR Cli_Bairro like ?';
          sql += '   OR Cli_Cidade like ?)';
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
          data.push('%' + search + '%');
        }
        if (codRota > 0) {
          sql += ' AND Rot_Codigo = ?';
          data.push(codRota);
        }

        sql += ' ORDER BY Cli_NomeFantasia LIMIT 50';

        return db.executeSql(sql, data)
          .then((data: any) => {
            if (data.rows.length > 0) {
              let clientes: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var cliente = new Cliente();
                cliente.codigo = data.rows.item(i).Cli_Codigo;
                cliente.nomefantasia = data.rows.item(i).Cli_NomeFantasia;
                cliente.razaosocial = data.rows.item(i).Cli_RazaoSocial;
                cliente.cpf_cnpj = data.rows.item(i).Cli_CPFCNPJ;
                cliente.rg_ie = data.rows.item(i).Cli_RGIE;
                cliente.email = data.rows.item(i).Cli_Email;
                cliente.fone1 = data.rows.item(i).Cli_Fone1;
                cliente.fone2 = data.rows.item(i).Cli_Fone2;
                cliente.fax = data.rows.item(i).Cli_Fax;
                cliente.whatsapp = data.rows.item(i).Cli_Whats;
                cliente.celular = data.rows.item(i).Cli_Celular;
                cliente.endereco = data.rows.item(i).Cli_Endereco;
                cliente.nro_endereco = data.rows.item(i).Cli_NroEndereco;
                cliente.bairro = data.rows.item(i).Cli_Bairro;
                cliente.complemento = data.rows.item(i).Cli_Complemento;
                cliente.cep = data.rows.item(i).Cli_CEP;
                cliente.cidade = data.rows.item(i).Cli_Cidade;
                cliente.uf = data.rows.item(i).Cli_UF;
                cliente.codigo_municipio = data.rows.item(i).Cli_CodMunicipio;
                cliente.bloquear = data.rows.item(i).Cli_Bloquear;
                cliente.motivo_bloqueio = data.rows.item(i).Cli_MotivoBloqueio;
                cliente.cadastrado_app = data.rows.item(i).Cli_CadastradoApp;
                cliente.codigo_rota = data.rows.item(i).Rot_Codigo;
                clientes.push(cliente);
              }
              return clientes;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public exportar() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM clientes WHERE Cli_CadastradoApp = ?';

        return db.executeSql(sql, ['S'])
          .then(async (data: any) => {
            if (data.rows.length > 0) {
              let clientes: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                clientes.push(data.rows.item(i));
              }
              return { clientes: clientes, contador: data.rows.length };
            } else {
              return { clientes: [], contador: 0 };
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  async atualizaSincronizados() {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'update clientes set Cli_CadastradoApp = ? WHERE Cli_CadastradoApp = ?';
          let params = ['N', 'S'];

          await tx.executeSql(sql, params, (tx, resultSet) => {
            console.log('atualizou clientes sincronizados');
          }, (err) => {
            console.log('erro:' + err);
          });

        }).then();

      })
      .catch((e) => console.error(e));
  }
}

export class Cliente {
  codigo: number;
  nomefantasia: string;
  razaosocial: string;
  cpf_cnpj: string;
  rg_ie: string;
  email: string;
  fone1: string;
  fone2: string;
  fax: string;
  celular: string;
  whatsapp: string;
  endereco: string;
  nro_endereco: string;
  bairro: string;
  complemento: string;
  cep: string;
  cidade: string;
  uf: string;
  codigo_municipio: number;
  bloquear: string;
  motivo_bloqueio: string;
  cadastrado_app: string;
  status: String;
  codigo_rota: number;
  tabelas: Array<{}>;
}

export class ClienteTabela {
  codigo_tabela: number;
}



// WEBPACK FOOTER //
// ./src/providers/cliente/cliente.ts